
/**
 * @name crud_doctor_agenda_management.js
 * @author Fellipe Orsini
 * @package clinic-mvp\app\assets\js\crud_doctor_agenda_management.js
 */

//import { apiCall, getBaseDir } from './utils.js';

import Swal from 'sweetalert2';

var getBaseDir = null, apiCall = null, getBranchNameFromId = null, getWeekDayNameFromWeekDayId = null;

$(function()
{
    import('../../utils.js').then(utils => {
        getBaseDir = utils.getBaseDir;
        apiCall = utils.apiCall;
        getBranchNameFromId = utils.getBranchNameFromId;
        getWeekDayNameFromWeekDayId = utils.getWeekDayNameFromWeekDayId;

        if (!utils.isUserLoggedIn())
            return;

        // A partir dessa parte só vai executar os códigos abaixo quando estiver na página inicial
        if (location.pathname !== utils.getBaseDir() + 'agenda/gerar-agenda')
            return;

        new DoctorAgendaManagement(true, {
            getBaseDir: utils.getBaseDir,
            apiCall: utils.apiCall,
        });
    });
});

class DoctorAgendaManagement
{
    constructor(onloadList=false, deps = {})
    {
        this.deps = deps;
        this.businessId = -1;
        let self = this;

        this.currentEdittingDoctorHours = [];
        this.currentEdittingDoctorId = -1;
        this.currentChanges = [];
        this.edittingRows = [];
        this.currentBranchId = -1;
        this.currentDoctorData = false;
        this.multiAgendaSelectedCheckbox = [];

        if (onloadList) {
            var intv = setInterval(function() {
                if (!window._sessionData.businessBranches)
                    return;
                
                clearInterval(intv);
                
                self.businessId = window._sessionData.businessId;

                let mountBranchesSelectHtml = '<option value="">-- Selecione --</option>';
                for(let i in window._sessionData.businessBranches) {
                    let branch = window._sessionData.businessBranches[i];
                    mountBranchesSelectHtml += `<option value="${branch.ID}">${branch.FILIAL}</option>`;
                }
                //$('#insert_staff_business_branches').html(mountBranchesSelectHtml);
                //$('#edit_staff_business_branches').html(mountBranchesSelectHtml);
            }, 1000);

            function OnDoctorsReady() {
                const res = window.businessBranchDoctors;
                let tableHtml = '';
                for(let i in res) {
                    let doutor = res[i];
                    tableHtml += `
                        <tr>
                            <td data-label="#">${doutor.ID}</td>
                            <td data-label="Filial">${getBranchNameFromId(doutor.DOUTOR_FILIAL_ID)}</td>
                            <td data-label="Nome">${doutor.PRIMEIRO_NOME} (${doutor.STAFF_ID})</td>
                            <td data-label="Horários" class="text-center">
                                <button class="btn btn-primary btn-sm js-view-doctor-reserved-hours" data-bs-toggle="modal" data-bs-target="#modal-doctor-hour-config" data-doctor='${JSON.stringify(doutor)}'><i class="fas fa-business-time"></i> Configurar Horários de Atendimento</button> <i class="fas fa-info-circle" data-tippy-content="Configure os horários de atendimento do(a) ${doutor.PRIMEIRO_NOME}"></i> <br />

                                <button class="btn btn-primary btn-sm js-doctor-generate-agenda mt-2" data-bs-toggle="modal" data-bs-target="#modal-doctor-generate-agenda" data-doctor='${JSON.stringify(doutor)}'><i class="fas fa-clock"></i> Gerar Horários na Agenda</button> <i class="fas fa-info-circle" data-tippy-content="Após configurar os 'Horários de Atendimento' use esta ferramenta para Gerar os Horários na Agenda"></i> <br />

                                <!-- copiar agenda de um dia para o outro e de um doutor para o outro -->
                                <button class="btn btn-primary btn-sm js-doctor-copy-agenda mt-2" data-bs-toggle="modal" data-bs-target="#modal-doctor-copy-agenda" data-doctor='${JSON.stringify(doutor)}'><i class="fas fa-copy"></i> Copiar Horários da Agenda</button> <i class="fas fa-info-circle" data-tippy-content="Copie os horários de atendimento de um dia da semana para outro dia da semana. Ou você também pode copiar os horários de atendimento do(a) ${doutor.PRIMEIRO_NOME} para outro(a) doutor(a)."></i> <br />

                                <!-- migra agenda de um doutor para o outro -->
                                <button class="btn btn-primary btn-sm js-doctor-migrate-agenda mt-2" data-bs-toggle="modal" data-bs-target="#modal-doctor-migrate-agenda" data-doctor='${JSON.stringify(doutor)}'><i class="fas fa-exchange-alt"></i> Migrar Agendamentos</button> <i class="fas fa-info-circle" data-tippy-content="Migre os agendamentos do(a) ${doutor.PRIMEIRO_NOME} para outro(a) Doutor(a)"></i> <br />

                                <button class="btn btn-primary btn-sm js-doctor-delete-agenda mt-2" data-bs-toggle="modal" data-bs-target="#modal-doctor-delete-agenda" data-doctor='${JSON.stringify(doutor)}'><i class="fas fa-minus"></i> Exclui Horários da Agenda</button> <i class="fas fa-info-circle" data-tippy-content="Exclui horários da agenda do(a) ${doutor.PRIMEIRO_NOME}"></i> <br />

                                <!-- opção de reverter deve ser global no menu-->
                                <button class="btn btn-primary btn-sm js-doctor-revert-agenda mt-2 d-none" data-bs-toggle="modal" data-bs-target="#modal-doctor-revert-agenda"><i class="fas fa-history"></i> Reverte Agenda</button>
                            </td>
                        </tr>
                    `;
                }
                $('.js-doctor-agenda-mngmt-list').html(tableHtml);
                $(".js-doctor-agenda-mngmt-table").unblock();
            }
            window.doctorsReadyFunctions.push(OnDoctorsReady);

            this.bindElementsChanges()
        }
    }

    bindElementsChanges() {
        const self = this;

        let agendaGeneratorConfig = {
            startDate: '',
            endDate: ''
        }
        let agendaCopyConfig = {
            copyType: ''
        }
        this.creatingIntervalWarning = false;

        // Detecta clique para visualizar horários de um doutor
        $(document).on('click', '.js-view-doctor-reserved-hours', function() {
            let doctorData = $(this).data('doctor');
            self.currentDoctorData = doctorData;

            $('.js-doctor-schedule-hours-list').html('Por favor, aguarde. Carregando...');

            self.multiAgendaSelectedCheckbox = [];

            apiCall({
                method: 'GET',
                endpoint: `api/v1/doctor/reserved_hours`,
                data: {
                    doctor_id: doctorData.STAFF_ID
                },
                successCallback: function(res) {
                    console.log('crud_doctor_agenda_management.js/doctor/reserved_hours', 'GET', res);

                    let tableHtml = '';

                    self.currentEdittingDoctorHours = res.data;
                    self.currentEdittingDoctorId = doctorData.STAFF_ID;
                    self.currentChanges = [];
                    self.edittingRows = [];

                    for(let i in res.data) {
                        let hour = res.data[i];

                        let tipoPaciente = '';
                        for(let x in window._sessionData.patientTypes) {
                            let pacientType = window._sessionData.patientTypes[x];
                            if (pacientType.ID == hour.TIPO_PACIENTE_ID) {
                                tipoPaciente = pacientType.SIGLA;
                                break;
                            }
                        }

                        tableHtml += `
                            <tr id="reserved-hour-${hour.ID}">
                                <td data-label="#" style="width: 100px;">
                                    <div class="form-check">
                                        <input class="form-check-input js-doctor-agenda-mngmt-checkbox" type="checkbox" value="${hour.ID}" id="doctor-agenda-checkbox-${hour.ID}" name="doctor-agenda-checkbox-${hour.ID}" data-row-id='${hour.ID}' data-info='${JSON.stringify(hour)}'>
                                        <i class="fas fa-save js-save-current-row d-none ml-1" data-row-id='${hour.ID}' data-info='${JSON.stringify(hour)}'></i>
                                        <i class="fas fa-pen js-update-current-row ml-1" data-row-id='${hour.ID}' data-info='${JSON.stringify(hour)}'></i>
                                        <i class="fas fa-trash js-delete-current-row ml-1" data-row-id='${hour.ID}' data-info='${JSON.stringify(hour)}'></i>
                                    </div>
                                </td>
                                <td data-label="#">${hour.ID}</td>
                                <td data-label="#" class="dia-semana-${hour.ID}">${getWeekDayNameFromWeekDayId(hour.DIA_SEMANA)}</td>
                                <td data-label="#" class="tipo-paciente-${hour.ID}">${tipoPaciente}</td>
                                <td data-label="#" class="hora-inicio-${hour.ID}">${hour.HORA_INICIO}</td>
                                <td data-label="#" class="hora-fim-${hour.ID}">${hour.HORA_FIM}</td>
                                <td data-label="#">${doctorData.PRIMEIRO_NOME}</td>
                                <td data-label="#" class="status-agenda-${hour.ID}">${hour.STATUS === 'A' ? 'Ativo' : 'Inativo'}</td>
                            </tr>
                        `;
                    }
                    $('.js-doctor-schedule-hours-list').html(tableHtml);
                },
                errorCallback: function(err) {
                    console.error('ERROR', 'crud_doctor_agenda_management.js/doctor/reserved_hours', 'GET', err);
                }
            })
        });

        // Detecta clique para adicionar novo horário na agenda do doutor
        $(document).on('click', '.js-doctor-schedule-hours-add', function() {
            /*console.log('self.currentEdittingDoctorHours', self.currentEdittingDoctorHours);
            console.log('self.currentEdittingDoctorId', self.currentEdittingDoctorId);*/

            self.currentEdittingDoctorHours.push({
                ID: 65535,
                DOUTORES_ID: self.currentEdittingDoctorId,
                DIA_SEMANA: 1,
                HORA_INICIO: '',
                HORA_FIM: '',
                TIPO_PACIENTE_ID: 1,
                STATUS: 'A',
                FILIAL_ID: self.currentBranchId
            });

            let editableTableRow = `
                <tr data-row-id="65535">
                    <td data-label="#">
                        <i class="fas fa-save js-save-new-row"></i>
                        <i class="fas fa-times js-remove-new-row"></i>
                    </td>
                    <td data-label="#"></td>
                    <td data-label="#" class="dia-semana">
                        <select name="edit_dia_semana" data-row-id="65535" class="form-control">
                            <option value="1" selected>Segunda-feira</option>
                            <option value="2">Terça-feira</option>
                            <option value="3">Quarta-feira</option>
                            <option value="4">Quinta-feira</option>
                            <option value="5">Sexta-feira</option>
                            <option value="6">Sábado</option>
                            <option value="7">Domingo</option>
                        </select>
                    </td>
                    <td data-label="#" class="tipo-paciente">
                        <select name="edit_tipo_paciente" class="form-control" data-row-id="65535">
                            ${window._sessionData.patientTypes.map((pt) => {
                                return `<option value="${pt.ID}">${pt.SIGLA}</option>`;
                            })}
                        </select>
                    </td>
                    <td data-label="#" class="hora-inicio"><input type="text" name="edit_hora_inicio" data-row-id="65535" class="form-control" value=""></td>
                    <td data-label="#" class="hora-fim"><input type="text" name="edit_hora_fim" data-row-id="65535" class="form-control" value=""></td>
                    <td data-label="#">${self.currentDoctorData.PRIMEIRO_NOME}</td>
                    "#" class="status-agenda">
                        <select name="edit_status_agenda" class="form-control" data-row-id="65535">
                            <option value="A">Ativo</option>
                            <option value="I">Inativo</option>
                        </select>
                    </td>
                </tr>
            `;
            $('.js-doctor-schedule-hours-list').append(editableTableRow);

            $('input[name="edit_hora_inicio"]').mask('00:00');
            $('input[name="edit_hora_fim"]').mask('00:00');
        });

        // Detecta clique na canetinha dos horários para permitir edição
        $(document).on('click', '.js-update-current-row', function() {
            let rowId = $(this).data('row-id');
            let rowInfo = JSON.parse($(this).attr('data-info'));

            /*console.log('rowInfo', rowInfo);
            console.log('self.edittingRows.indexOf(rowId)', self.edittingRows.indexOf(rowId));*/

            if (self.edittingRows.indexOf(rowId) === -1) {
                $('#doctor-agenda-checkbox-'+rowId).addClass('d-none');
                $('.dia-semana-'+rowId).html(`<select name="edit_dia_semana" data-row-id="${rowInfo.ID}" class="form-control">
                    <option value="1" ${(rowInfo.DIA_SEMANA) == 1 ? 'selected' : ''}>Segunda-feira</option>
                    <option value="2" ${(rowInfo.DIA_SEMANA) == 2 ? 'selected' : ''}>Terça-feira</option>
                    <option value="3" ${(rowInfo.DIA_SEMANA) == 3 ? 'selected' : ''}>Quarta-feira</option>
                    <option value="4" ${(rowInfo.DIA_SEMANA) == 4 ? 'selected' : ''}>Quinta-feira</option>
                    <option value="5" ${(rowInfo.DIA_SEMANA) == 5 ? 'selected' : ''}>Sexta-feira</option>
                    <option value="6" ${(rowInfo.DIA_SEMANA) == 6 ? 'selected' : ''}>Sábado</option>
                    <option value="7" ${(rowInfo.DIA_SEMANA) == 7 ? 'selected' : ''}>Domingo</option>
                </select>`);
                $('.hora-inicio-'+rowId).html(`<input type="text" name="edit_hora_inicio" data-row-id="${rowInfo.ID}" class="form-control" value="${rowInfo.HORA_INICIO}">`);
                $('.hora-fim-'+rowId).html(`<input type="text" name="edit_hora_fim" data-row-id="${rowInfo.ID}" class="form-control" value="${rowInfo.HORA_FIM}">`);
                $('.tipo-paciente-'+rowId).html(`<select name="edit_tipo_paciente" data-row-id="${rowInfo.ID}" class="form-control">
                    ${window._sessionData.patientTypes.map((pt) => {
                        return `<option value="${pt.ID}" ${pt.ID == rowInfo.TIPO_PACIENTE_ID ? 'selected' : ''}>${pt.SIGLA}</option>`;
                    })}
                </select>`);
                $('.status-agenda-'+rowId).html(`<select name="edit_status_agenda" data-row-id="${rowInfo.ID}" class="form-control">
                    <option value="A" ${rowInfo.STATUS == 'A' ? 'selected' : ''}>Ativo</option>
                    <option value="I" ${rowInfo.STATUS == 'I' ? 'selected' : ''}>Inativo</option>
                </select>`);
                self.edittingRows.push(rowId);

                $(this).addClass('d-none');
                $(this).parent().find('.js-save-current-row').removeClass('d-none');

                $('input[name="edit_hora_inicio"]').mask('00:00');
                $('input[name="edit_hora_fim"]').mask('00:00');
            } else {
                let tipoPaciente = '';
                for(let x in window._sessionData.patientTypes) {
                    let pacientType = window._sessionData.patientTypes[x];
                    if (pacientType.ID == rowInfo.TIPO_PACIENTE_ID) {
                        tipoPaciente = pacientType.SIGLA;
                        break;
                    }
                }

                $('#doctor-agenda-checkbox-'+rowId).removeClass('d-none');
                $('.dia-semana-'+rowId).html(getWeekDayNameFromWeekDayId(rowInfo.DIA_SEMANA));
                $('.hora-inicio-'+rowId).html(rowInfo.HORA_INICIO);
                $('.hora-fim-'+rowId).html(rowInfo.HORA_FIM);
                $('.tipo-paciente-'+rowId).html(tipoPaciente);
                $('.status-agenda-'+rowId).html(rowInfo.STATUS === 'A' ? 'Ativo' : 'Inativo');
                self.edittingRows.splice(self.edittingRows.indexOf(rowId), 1);
            }
        });

        // Detecta clique no botão de salvar após editar um horário
        $(document).on('click', '.js-save-current-row', function() {
            let rowId = $(this).data('row-id');
            let rowInfo = JSON.parse($(this).attr('data-info'));

            let selfBtn = $(this);

            if (self.edittingRows.indexOf(rowId) !== -1) {
                Swal.fire({
                    title: 'Salvar alterações',
                    text: 'Deseja realmente salvar as alterações feitas nesse horário?',
                    icon: 'warning',
                    showCancelButton: true,
                    confirmButtonColor: '#3085d6',
                    cancelButtonColor: '#d33',
                    confirmButtonText: 'Sim, salvar!',
                    cancelButtonText: 'Cancelar'
                }).then((result) => {
                    if (result.isConfirmed) {
                        let updatedData = {
                            ID: rowInfo.ID,
                            DOUTORES_ID: rowInfo.DOUTORES_ID,
                            DIA_SEMANA: $('select[name="edit_dia_semana"]').val(),
                            HORA_INICIO: $('input[name="edit_hora_inicio"]').val(),
                            HORA_FIM: $('input[name="edit_hora_fim"]').val(),
                            TIPO_PACIENTE_ID: $('select[name="edit_tipo_paciente"]').val(),
                            STATUS: $('select[name="edit_status_agenda"]').val(),
                            FILIAL_ID: rowInfo.FILIAL_ID
                        };
                        
                        apiCall({
                            method: 'PUT',
                            endpoint: `api/v1/doctor/reserved_hours`,
                            data: updatedData,
                            successCallback: function(res) {
                                console.log('crud_doctor_agenda_management.js/doctor/reserved_hours', 'PUT', res);
                                if (res.error)
                                    return window.toast({
                                        text: res.message,
                                        error: true
                                    });
                                            
                                let tipoPaciente = '';
                                for(let x in window._sessionData.patientTypes) {
                                    let pacientType = window._sessionData.patientTypes[x];
                                    if (pacientType.ID == rowInfo.TIPO_PACIENTE_ID) {
                                        tipoPaciente = pacientType.SIGLA;
                                        break;
                                    }
                                }
                
                                $('#doctor-agenda-checkbox-'+rowId).removeClass('d-none');
                                $('.dia-semana-'+rowId).html(getWeekDayNameFromWeekDayId(rowInfo.DIA_SEMANA));
                                $('.hora-inicio-'+rowId).html(rowInfo.HORA_INICIO);
                                $('.hora-fim-'+rowId).html(rowInfo.HORA_FIM);
                                $('.tipo-paciente-'+rowId).html(tipoPaciente);
                                $('.status-agenda-'+rowId).html(rowInfo.STATUS === 'A' ? 'Ativo' : 'Inativo');
                                self.edittingRows.splice(self.edittingRows.indexOf(rowId), 1);

                                selfBtn.addClass('d-none');
                                selfBtn.parent().find('.js-update-current-row').removeClass('d-none');
                            },
                            errorCallback: function(err) {
                                console.error('ERROR', 'crud_doctor_agenda_management.js/doctor/reserved_hours', 'PUT', err);
                            }
                        });
                    }
                });
            }
        });

        // Detecta clique para excluir um horário
        $(document).on('click', '.js-delete-current-row', function() {
            let rowId = $(this).data('row-id');
            let rowInfo = $(this).data('info');

            Swal.fire({
                title: 'Excluir horário',
                text: 'Deseja realmente excluir esse horário? Essa ação é irreversível!',
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#d33',
                cancelButtonColor: '#3085d6',
                confirmButtonText: 'Sim, excluir!',
                cancelButtonText: 'Cancelar'
            }).then((result) => {
                if (result.isConfirmed) {
                    apiCall({
                        method: 'DELETE',
                        endpoint: `api/v1/doctor/reserved_hours`,
                        data: {
                            hour_id: rowInfo.ID
                        },
                        successCallback: function(res) {
                            console.log('crud_doctor_agenda_management.js/doctor/reserved_hours', 'DELETE', res);
                            if (res.error)
                                return window.toast({
                                    text: res.message,
                                    type: 'error'
                                })
                            $('#reserved-hour-'+rowInfo.ID).remove();
                            if (self.edittingRows.indexOf(rowId) !== -1) {
                                self.edittingRows.splice(self.edittingRows.indexOf(rowId), 1);
                            }
                            self.currentEdittingDoctorHours = self.currentEdittingDoctorHours.filter((hour) => hour.ID !== rowInfo.ID);
                            /*self.currentChanges.push({
                                type: 'delete',
                                data: rowInfo
                            })*/
                            //self.deletedHours.push(rowInfo.ID);
                        },
                        errorCallback: function(err) {
                            console.error('ERROR', 'crud_doctor_agenda_management.js/doctor/reserved_hours', 'DELETE', err);
                        }
                    })
                }
            });
        });

        // Detecta alteração na seleção de horários
        $(document).on('change', '.js-doctor-agenda-mngmt-checkbox', function() {
            if ($(this).is(':checked')) {
                self.multiAgendaSelectedCheckbox.push($(this).val());
                self.generateFixedBarAtBottomIfHasAnySelectedCheckbox();
            } else {
                self.multiAgendaSelectedCheckbox = self.multiAgendaSelectedCheckbox.filter((id) => id !== $(this).val());
                self.generateFixedBarAtBottomIfHasAnySelectedCheckbox();
            }
            console.log('self.multiAgendaSelectedCheckbox', self.multiAgendaSelectedCheckbox);
        });

        // Detecta clique no botão de excluir horários selecionados
        $(document).on('click', '.js-doctor-schedule-hours-save', function() {
            console.log('self.multiAgendaSelectedCheckbox', self.multiAgendaSelectedCheckbox);
            Swal.fire({
                title: 'Excluir horários selecionados',
                text: 'Deseja realmente excluir os horários selecionados?',
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#d33',
                cancelButtonColor: '#3085d6',
                confirmButtonText: 'Sim, excluir!',
                cancelButtonText: 'Cancelar'
            }).then((result) => {
                if (result.isConfirmed) {
                    console.log('excluir horários selecionados');
                    apiCall({
                        method: 'DELETE',
                        endpoint: `api/v1/doctor/reserved_hours`,
                        data: {
                            hours_ids: self.multiAgendaSelectedCheckbox
                        },
                        successCallback: function(res) {
                            console.log('crud_doctor_agenda_management.js/doctor/reserved_hours', 'DELETE', res);
                            if (res.error)
                                return window.toast({
                                    text: res.message,
                                    type: 'error'
                                });

                            self.multiAgendaSelectedCheckbox.forEach((id) => {
                                $('#reserved-hour-'+id).remove();
                            });
                            self.multiAgendaSelectedCheckbox = [];
                            self.generateFixedBarAtBottomIfHasAnySelectedCheckbox();
                        },
                        errorCallback: function(err) {
                            console.error('ERROR', 'crud_doctor_agenda_management.js/doctor/reserved_hours', 'DELETE', err);
                        }
                    });
                }
            });
        });

        // Detecta alteração no select de dia da semana (durante a edição de um horário)
        $(document).on('change', 'select[name="edit_dia_semana"]', function() {
            let rowId = $(this).data('row-id');
            let rowInfo = self.currentEdittingDoctorHours.find((hour) => hour.ID == rowId);
            let newWeekDay = $(this).val();

            rowInfo.DIA_SEMANA = newWeekDay;
            self.currentEdittingDoctorHours = self.currentEdittingDoctorHours.map((hour) => {
                if (hour.ID == rowId) {
                    hour.DIA_SEMANA = newWeekDay;
                }
                return hour;
            });
            $('[data-row-id="'+rowId+'"]').attr('data-info', JSON.stringify(rowInfo));

            let found = false;
            for(let i in self.currentChanges) {
                let change = self.currentChanges[i];
                if (change.data.ID == rowId) {
                    found = true;
                    change.data.DIA_SEMANA = newWeekDay;
                    break;
                }
            }
            //console.log('found', found);
            if (!found) {
                self.currentChanges.push({
                    type: 'update',
                    data: rowInfo
                });
                /*console.log('found', found);
                console.log('self.currentChanges', self.currentChanges);*/
            }
            
            self.updateSaveButton();
        });

        // Detecta alteração no input de hora de início (durante a edição de um horário)
        $(document).on('change', 'input[name="edit_hora_inicio"]', function() {
            let rowId = $(this).data('row-id');
            let rowInfo = self.currentEdittingDoctorHours.find((hour) => hour.ID == rowId);
            let newHour = $(this).val();

            rowInfo.HORA_INICIO = newHour;
            self.currentEdittingDoctorHours = self.currentEdittingDoctorHours.map((hour) => {
                if (hour.ID == rowId) {
                    hour.HORA_INICIO = newHour;
                }
                return hour;
            });
            $('[data-row-id="'+rowId+'"]').attr('data-info', JSON.stringify(rowInfo));

            let found = false;
            for(let i in self.currentChanges) {
                let change = self.currentChanges[i];
                if (change.data.ID == rowId) {
                    found = true;
                    change.data.HORA_INICIO = newHour;
                    break;
                }
            }
            if (!found) {
                self.currentChanges.push({
                    type: 'update',
                    data: rowInfo
                });
            }
            self.updateSaveButton();
        });

        // Detecta alteração no input de hora de fim (durante a edição de um horário)
        $(document).on('change', 'input[name="edit_hora_fim"]', function() {
            let rowId = $(this).data('row-id');
            let rowInfo = self.currentEdittingDoctorHours.find((hour) => hour.ID == rowId);
            let newHour = $(this).val();

            rowInfo.HORA_FIM = newHour;
            self.currentEdittingDoctorHours = self.currentEdittingDoctorHours.map((hour) => {
                if (hour.ID == rowId) {
                    hour.HORA_FIM = newHour;
                }
                return hour;
            });
            $('[data-row-id="'+rowId+'"]').attr('data-info', JSON.stringify(rowInfo));

            let found = false;
            for(let i in self.currentChanges) {
                let change = self.currentChanges[i];
                if (change.data.ID == rowId) {

                    found = true;
                    change.data.HORA_FIM = newHour;
                    break;
                }
            }
            if (!found) {
                self.currentChanges.push({
                    type: 'update',
                    data: rowInfo
                });
            }
            self.updateSaveButton();
        });

        // Detecta alteração no select de tipo de paciente (durante a edição de um horário)
        $(document).on('change', 'select[name="edit_tipo_paciente"]', function() {
            let rowId = $(this).data('row-id');
            let rowInfo = self.currentEdittingDoctorHours.find((hour) => hour.ID == rowId);
            let newPacientType = $(this).val();

            rowInfo.TIPO_PACIENTE_ID = newPacientType;
            self.currentEdittingDoctorHours = self.currentEdittingDoctorHours.map((hour) => {
                if (hour.ID == rowId) {
                    hour.TIPO_PACIENTE_ID = newPacientType;
                }
                return hour;
            });
            $('[data-row-id="'+rowId+'"]').attr('data-info', JSON.stringify(rowInfo));

            let found = false;
            for(let i in self.currentChanges) {
                let change = self.currentChanges[i];
                if (change.data.ID == rowId) {
                    found = true;
                    change.data.TIPO_PACIENTE_ID = newPacientType;
                    break;
                }
            }
            if (!found) {
                self.currentChanges.push({
                    type: 'update',
                    data: rowInfo
                });
            }
            self.updateSaveButton();
        });

        // Detecta alteração no select de status da agenda (durante a edição de um horário)
        $(document).on('change', 'select[name="edit_status_agenda"]', function() {
            let rowId = $(this).data('row-id');
            let rowInfo = self.currentEdittingDoctorHours.find((hour) => hour.ID == rowId);
            let newStatus = $(this).val();

            rowInfo.STATUS = newStatus;
            self.currentEdittingDoctorHours = self.currentEdittingDoctorHours.map((hour) => {
                if (hour.ID == rowId) {
                    hour.STATUS = newStatus;
                }
                return hour;
            });
            $('[data-row-id="'+rowId+'"]').attr('data-info', JSON.stringify(rowInfo));

            let found = false;
            for(let i in self.currentChanges) {
                let change = self.currentChanges[i];
                if (change.data.ID == rowId) {
                    found = true;
                    change.data.STATUS = newStatus;
                    break;
                }
            }
            if (!found) {
                self.currentChanges.push({
                    type: 'update',
                    data: rowInfo
                });
            }
            self.updateSaveButton();
        });

        // Detecta seleção da filial e salva o ID da filial selecionada
        $(document).on('change', '.js-business-branches-selector', function() {
            self.currentBranchId = $(this).val();
        });

        // Detecta clique para salvar o novo horário adicionado
        $(document).on('click', '.js-save-new-row', function() {
            let selfBtn = $(this);

            Swal.fire({
                title: 'Salvar novo horário',
                text: 'Deseja realmente salvar esse novo horário?',
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Sim, salvar!',
                cancelButtonText: 'Cancelar'
            }).then((result) => {
                if (result.isConfirmed) {
                    let newHour = {
                        ID: 65535,
                        DOUTORES_ID: self.currentEdittingDoctorId,
                        DIA_SEMANA: $('select[name="edit_dia_semana"]').val(),
                        HORA_INICIO: $('input[name="edit_hora_inicio"]').val(),
                        HORA_FIM: $('input[name="edit_hora_fim"]').val(),
                        TIPO_PACIENTE_ID: $('select[name="edit_tipo_paciente"]').val(),
                        STATUS: $('select[name="edit_status_agenda"]').val(),
                        FILIAL_ID: self.currentBranchId
                    };

                    apiCall({
                        method: 'POST',
                        endpoint: `api/v1/doctor/reserved_hours`,
                        data: newHour,
                        successCallback: function(res) {
                            console.log('crud_doctor_agenda_management.js/doctor/reserved_hours', 'POST', res);
                            if (res.error)
                                return window.toast({
                                    text: res.message,
                                    error: true
                                });

                            let tipoPaciente = '';
                            for(let x in window._sessionData.patientTypes) {
                                let pacientType = window._sessionData.patientTypes[x];
                                if (pacientType.ID == newHour.TIPO_PACIENTE_ID) {
                                    tipoPaciente = pacientType.SIGLA;
                                    break;
                                }
                            }
            
                            let newRowHtml = `
                                <tr id="reserved-hour-${res.data.ID}">
                                    <td data-label="#">
                                        <div class="form-check">
                                            <input class="form-check-input js-doctor-agenda-mngmt-checkbox" type="checkbox" value="${res.data.ID}" id="doctor-agenda-checkbox-${res.data.ID}" name="doctor-agenda-checkbox-${res.data.ID}" data-row-id='${res.data.ID}' data-info='${JSON.stringify(res.data)}'>
                                            <i class="fas fa-save js-save-current-row d-none ml-1" data-row-id='${res.data.ID}' data-info='${JSON.stringify(res.data)}'></i>
                                            <i class="fas fa-pen js-update-current-row ml-1" data-row-id='${res.data.ID}' data-info='${JSON.stringify(res.data)}'></i>
                                            <i class="fas fa-trash js-delete-current-row ml-1" data-row-id='${res.data.ID}' data-info='${JSON.stringify(res.data)}'></i>
                                        </div>
                                    </td>
                                    <td data-label="#">${res.data.ID}</td>
                                    <td data-label="#" class="dia-semana-${res.data.ID}">${getWeekDayNameFromWeekDayId(res.data.DIA_SEMANA)}</td>
                                    <td data-label="#" class="tipo-paciente-${res.data.ID}">${tipoPaciente}</td>
                                    <td data-label="#" class="hora-inicio-${res.data.ID}">${res.data.HORA_INICIO}</td>
                                    <td data-label="#" class="hora-fim-${res.data.ID}">${res.data.HORA_FIM}</td>
                                    <td data-label="#">${self.currentDoctorData.PRIMEIRO_NOME}</td>
                                    <td data-label="#" class="status-agenda-${res.data.ID}">${res.data.STATUS === 'A' ? 'Ativo' : 'Inativo'}</td>
                                </tr>
                            `;
                            $('.js-doctor-schedule-hours-list').append(newRowHtml);
                            self.currentEdittingDoctorHours.push(res.data);
                            self.currentEdittingDoctorHours = self.currentEdittingDoctorHours.filter((hour) => hour.ID !== 65535);

                            $('tr[data-row-id="65535"]').remove();
                        },
                        errorCallback: function(err) {
                            console.error('ERROR', 'crud_doctor_agenda_management.js/doctor/reserved_hours', 'POST', err);
                        }
                    });
                }
            });
        });

        // Detecta clique para cancelar a adição de um novo horário
        $(document).on('click', '.js-remove-new-row', function() {
            $('tr[data-row-id="65535"]').remove();
            self.currentEdittingDoctorHours = self.currentEdittingDoctorHours.filter((hour) => hour.ID !== 65535);
        });

        // ================== GERAÇÃO DE AGENDA

        $(document).on('click', '.js-doctor-generate-agenda', function() {
            let doctor = $(this).data('doctor');
            $('#doctor_generate_agenda_doctor').val(doctor.PRIMEIRO_NOME);
            self.currentDoctorData = doctor;
        });

        $(document).on('change', 'input[name="doctor_generate_agenda_start_date"]', function () {
            agendaGeneratorConfig.startDate = $(this).val();
        });

        $(document).on('change', 'input[name="doctor_generate_agenda_end_date"]', function () {
            agendaGeneratorConfig.endDate = $(this).val();
        });

        // check if both dates are selected
        $(document).on('change', 'input[name="doctor_generate_agenda_start_date"],input[name="doctor_generate_agenda_end_date"]', function () {
            if (agendaGeneratorConfig.startDate === '' || agendaGeneratorConfig.endDate === '') {
                return window.toast({
                    text: 'Por favor, selecione a data de início e fim para gerar a agenda',
                    error: true
                });
            }
            
            // get avaiable saturdays between dates
            let availableSaturdays = [];
            let start = new Date(agendaGeneratorConfig.startDate + 'T00:00:00');
            let end = new Date(agendaGeneratorConfig.endDate + 'T23:59:59');
            let loop = new Date(start);
            /*console.log('agendaGeneratorConfig', agendaGeneratorConfig);
            console.log('start loop', loop);
            console.log('end loop', end);*/
            while(loop <= end) {
                //console.log('current day', new Date(loop), loop.getDay());
                if (loop.getDay() === 6) {
                    availableSaturdays.push(new Date(loop)); // Create a new Date object to avoid reference issues
                    //console.log ('pushed', loop);
                }
                loop.setDate(loop.getDate() + 1);
                //console.log('next date in loop', new Date(loop));
            }
            //console.log('availableSaturdays', availableSaturdays);
            let saturdaysHtml = '';
            for(let i in availableSaturdays) {
                let saturday = availableSaturdays[i];
                saturdaysHtml += `<option value="${moment(saturday).format('YYYY-MM-DD')}">${moment(saturday).format('DD/MM/YYYY')}</option>`;
            }
            if (availableSaturdays.length === 0) {
                saturdaysHtml = '<option value="">Nenhum sábado disponível</option>';
            }
            $('#doctor_generate_agenda_saturdays').html(saturdaysHtml);
        });

        // verifies if both dates have been selected
        $(document).on('submit', '.js-doctor-generate-agenda-form', function(e) {
            e.preventDefault();

            if (agendaGeneratorConfig.startDate === '' || agendaGeneratorConfig.endDate === '') {
                return window.toast({
                    text: 'Por favor, selecione a data de início e fim para gerar a agenda',
                    error: true
                });
            }

            // verifies if both dates are in the same month and year
            let start = moment(agendaGeneratorConfig.startDate);
            let end = moment(agendaGeneratorConfig.endDate);
            if (start.format('MM') !== end.format('MM') || start.format('YYYY') !== end.format('YYYY')) {
                return window.toast({
                    text: 'Por favor, selecione datas que estejam no mesmo mês e ano',
                    error: true
                });
            }

            let data = $(this).serializeArray();
            // agregate all doctor_generate_agenda_saturdays in one value
            let saturdaysStr = '';
            for(let i = 0; i < data.length; ++i) {
                if (data[i].name === 'doctor_generate_agenda_saturdays') {
                    saturdaysStr += (saturdaysStr != '' ? ',' : '') + data[i].value;
                    delete data[i];
                }
            }
            // filter null values
            data = data.filter((d) => d.value !== null);

            //console.log('self.currentDoctorData', self.currentDoctorData);

            data.push({
                name: 'doctor_generate_agenda_saturdays',
                value: saturdaysStr
            })
            data.push({
                name: 'doctor_generate_agenda_doctor',
                value: self.currentDoctorData.STAFF_ID
            })

            let selfForm = this;
            $(this).find('button[type="submit"]').attr('disabled', true);

            window.toast({
                text: 'Aguarde, gerando a agenda... Isso pode levar alguns minutos',
                error: true,
                style: 'warning'
            });
            self.creatingIntervalWarning = setInterval(function() {
                window.toast({
                    text: 'Aguarde, gerando a agenda... Isso pode levar alguns minutos',
                    error: true,
                    style: 'warning'
                })
            }, 5500);

            // call the api to generate the schedule
            apiCall({
                method: 'POST',
                endpoint: `api/v1/agenda/doctor_generate_schedule`,
                data: data,
                successCallback: function(res) {
                    console.log('crud_doctor_agenda_management.js/doctor/generate_schedule', 'POST', res);
                    clearInterval(self.creatingIntervalWarning);
                    self.creatingIntervalWarning = false;
                    $(selfForm).find('button[type="submit"]').attr('disabled', false);

                    if (res.error)
                        return Swal.fire({
                            title: 'Erro ao gerar a agenda',
                            text: res.message,
                            icon: 'error',
                            showConfirmButton: true,
                            confirmButtonText: 'OK'
                        });

                    agendaGeneratorConfig.startDate = '';
                    agendaGeneratorConfig.endDate = '';

                    Swal.fire({
                        title: 'Agenda do(a) ' + self.currentDoctorData.PRIMEIRO_NOME + ' gerada com sucesso!',
                        text: res.message,
                        error: false,
                        type: 'success',
                        showConfirmButton: true,
                        confirmButtonText: 'OK'
                    });
                    $(selfForm).trigger('reset');
                },
                errorCallback: function(err) {
                    clearInterval(self.creatingIntervalWarning);
                    self.creatingIntervalWarning = false;
                    $(selfForm).find('button[type="submit"]').attr('disabled', false);
                    window.toast({
                        text: 'Ocorreu um erro ao gerar a agenda. Por favor, tente novamente',
                        type: 'error'
                    });
                    console.error('ERROR', 'crud_doctor_agenda_management.js/doctor/generate_schedule', 'POST', err);
                }
            });
        });

        $(document).on('click', '.js-doctor-generate-agenda-close', function() {
            if (self.creatingIntervalWarning) {
                return window.toast({
                    text: 'Aguarde, a geração da agenda está em andamento',
                    error: true
                });
            }
            clearInterval(self.creatingIntervalWarning);
            self.creatingIntervalWarning = false;
            agendaGeneratorConfig.startDate = '';
            agendaGeneratorConfig.endDate = '';
            $('.js-doctor-generate-agenda-form').trigger('reset');
        });

        // ================== GERAÇÃO DE AGENDA

        // ================== COPIAR AGENDA

        $(document).on('click', '.js-doctor-copy-agenda', function() {
            let doctor = $(this).data('doctor');
            self.currentDoctorData = doctor;
            //console.log('doctor', doctor);

            $('input[id="doctor_copy_agenda_branch_origin_name"]').val($('.js-agenda-branches-selector option:selected').text());
            $('input[id="doctor_copy_agenda_origin_doctor"]').val(doctor.PRIMEIRO_NOME);
        });

        $(document).on('change', 'select[name="doctor_copy_agenda_type"]', function() {
            agendaCopyConfig.copyType = $(this).val();

            if (agendaCopyConfig.copyType == 1) {
                $('.js-copy-type-1').removeClass('d-none');
                $('.js-copy-type-2').addClass('d-none');

                $('#doctor_copy_agenda_weekday_origin').attr('readonly', true);
                $('#doctor_copy_agenda_weekday_destiny').attr('readonly', true);
                $('.js-doctor-copy-agenda-form').find('button[type="submit"]').attr('disabled', true);

                // get doctor week days and avaiable days to copy
                apiCall({
                    method: 'GET',
                    endpoint: `api/v1/agenda/doctor_week_days`,
                    data: {
                        doctor_id: self.currentDoctorData.STAFF_ID,
                        weekDay: 1
                    },
                    successCallback: function(res) {
                        console.log('crud_doctor_agenda_management.js/doctor/week_days', 'GET', res);
                        if (res.error)
                            return window.toast({
                                text: res.message,
                                error: true
                            });

                        let weekDaysHtml = '';
                        for(let i in res.data_origin) {
                            let weekDay = res.data_origin[i];
                            weekDaysHtml += `<option value="${weekDay.ID}">${weekDay.DIA}</option>`;
                        }
                        $('#doctor_copy_agenda_weekday_origin').html(weekDaysHtml);

                        let weekDaysHtml2 = '';
                        for(let i in res.data_destiny) {
                            let weekDay = res.data_destiny[i];
                            weekDaysHtml2 += `<option value="${weekDay.ID}">${weekDay.DIA}</option>`;
                        }
                        $('#doctor_copy_agenda_weekday_destiny').html(weekDaysHtml2);

                        $('#doctor_copy_agenda_weekday_origin').attr('readonly', false);
                        $('#doctor_copy_agenda_weekday_destiny').attr('readonly', false);
                        $('.js-doctor-copy-agenda-form').find('button[type="submit"]').attr('disabled', false);
                    },
                    errorCallback: function(err) {
                        console.error('ERROR', 'crud_doctor_agenda_management.js/doctor/week_days', 'GET', err);
                    }
                });
            } else if (agendaCopyConfig.copyType == 2) {
                $('.js-copy-type-2').removeClass('d-none');
                $('.js-copy-type-1').addClass('d-none');
            } else {
                $('.js-copy-type-1').addClass('d-none');
                $('.js-copy-type-2').addClass('d-none');
            }
        });

        $(document).on('change', 'select[name="doctor_copy_agenda_weekday_origin"]', function() {
            let doctorId = self.currentDoctorData.STAFF_ID;
            let weekDay = $(this).val();

            $('#doctor_copy_agenda_weekday_origin').attr('readonly', true);
            $('#doctor_copy_agenda_weekday_destiny').attr('readonly', true);
            $('.js-doctor-copy-agenda-form').find('button[type="submit"]').attr('disabled', true);

            apiCall({
                method: 'GET',
                endpoint: `api/v1/agenda/doctor_week_days`,
                data: {
                    doctor_id: doctorId,
                    weekDay: weekDay
                },
                successCallback: function(res) {
                    console.log('crud_doctor_agenda_management.js/doctor/available_days', 'GET', res);
                    if (res.error)
                        return window.toast({
                            text: res.message,
                            error: true
                        });

                    let availableDaysHtml = '';
                    for(let i in res.data_destiny) {
                        let day = res.data_destiny[i];
                        availableDaysHtml += `<option value="${day.ID}">${day.DIA}</option>`;
                    }
                    $('#doctor_copy_agenda_weekday_destiny').html(availableDaysHtml);

                    $('#doctor_copy_agenda_weekday_origin').attr('readonly', false);
                    $('#doctor_copy_agenda_weekday_destiny').attr('readonly', false);
                    $('.js-doctor-copy-agenda-form').find('button[type="submit"]').attr('disabled', false);
                },
                errorCallback: function(err) {
                    console.error('ERROR', 'crud_doctor_agenda_management.js/doctor/available_days', 'GET', err);
                }
            });
        });

        $(document).on('submit', '.js-doctor-copy-agenda-form', function(e) {
            e.preventDefault();

            if (agendaCopyConfig.copyType == '')
                return window.toast({
                    text: 'Por favor, selecione o tipo de cópia que deseja realizar',
                    error: true
                });
                
            if (agendaCopyConfig.copyType == '1') {
                // validate origin weekday
                if ($('#doctor_copy_agenda_weekday_origin').val() == '')
                    return window.toast({
                        text: 'Por favor, selecione o dia da semana de origem',
                        error: true
                    });
                if ($('#doctor_copy_agenda_weekday_destiny').val() == '')
                    return window.toast({
                        text: 'Por favor, selecione o dia da semana de destino',
                        error: true
                    });
            }

            if (agendaCopyConfig.copyType == '2') {
                if ($('#doctor_copy_agenda_branch_target').val() == '')
                    return window.toast({
                        text: 'Por favor, selecione o dia de origem',
                        error: true
                    });
                if ($('#doctor_copy_agenda_target_doctor').val() == '')
                    return window.toast({
                        text: 'Por favor, selecione o dia de destino',
                        error: true
                    });
            }

            let data = $(this).serializeArray();
            let selfForm = this;

            $(this).find('button[type="submit"]').attr('disabled', true);

            data.push({
                name: 'doctor_copy_agenda_branch_origin_name',
                value: self.currentDoctorData.DOUTOR_FILIAL_ID
            })
            data.push({
                name: 'doctor_copy_agenda_origin_doctor',
                value: self.currentDoctorData.STAFF_ID
            })

            window.toast({
                text: 'Aguarde, copiando a agenda... Isso pode levar alguns minutos',
                error: true,
                style: 'warning'
            });

            apiCall({
                method: 'POST',
                endpoint: `api/v1/agenda/doctor_copy_schedule`,
                data: data,
                successCallback: function(res) {
                    console.log('crud_doctor_agenda_management.js/doctor/copy_schedule', 'POST', res);
                    $(selfForm).find('button[type="submit"]').attr('disabled', false);

                    if (res.error)
                        return Swal.fire({
                            title: 'Erro ao copiar a agenda',
                            text: res.message,
                            icon: 'error',
                            showConfirmButton: true,
                            confirmButtonText: 'OK'
                        });

                    Swal.fire({
                        title: 'Agenda do(a) ' + self.currentDoctorData.PRIMEIRO_NOME + ' copiada com sucesso!',
                        text: res.message,
                        icon: 'success',
                        showConfirmButton: true,
                        confirmButtonText: 'OK'
                    });
                    $(selfForm).trigger('reset');
                    $('#modal-doctor-copy-agenda').modal('hide');
                },
                errorCallback: function(err) {
                    $(selfForm).find('button[type="submit"]').attr('disabled', false);
                    window.toast({
                        text: 'Ocorreu um erro ao copiar a agenda. Por favor, tente novamente',
                        type: 'error'
                    });
                    console.error('ERROR', 'crud_doctor_agenda_management.js/doctor/copy_schedule', 'POST', err);
                }
            });
        });

        $(document).on('click', '.js-doctor-copy-agenda-close', function() {
            agendaCopyConfig.copyType = '';
            $('.js-copy-type-1').addClass('d-none');
            $('.js-copy-type-2').addClass('d-none');
            $('.js-doctor-copy-agenda-form').trigger('reset');
        });

        // ================== COPIAR AGENDA

        // ================== MIGRAR AGENDAMENTOS

        $(document).on('click', '.js-doctor-migrate-agenda', function() {
            let doctor = $(this).data('doctor');
            self.currentDoctorData = doctor;
            //console.log('doctor', doctor);

            $('input[id="doctor_migrate_agenda_branch_origin_name"]').val($('.js-agenda-branches-selector option:selected').text());
            $('input[id="doctor_migrate_agenda_doctor_origin_name"]').val(doctor.PRIMEIRO_NOME);
        });

        $(document).on('submit', '.js-doctor-migrate-agenda-form', function(e) {
            e.preventDefault();

            let data = $(this).serializeArray();
            let selfForm = this;

            $(this).find('button[type="submit"]').attr('disabled', true);

            data.push({
                name: 'doctor_migrate_agenda_branch_origin',
                value: self.currentDoctorData.DOUTOR_FILIAL_ID
            })
            data.push({
                name: 'doctor_migrate_agenda_doctor_origin',
                value: self.currentDoctorData.STAFF_ID
            })

            window.toast({
                text: 'Aguarde, migrando a agenda... Isso pode levar alguns minutos',
                error: true,
                style: 'warning'
            });

            apiCall({
                method: 'POST',
                endpoint: `api/v1/agenda/doctor_migrate_schedule`,
                data: data,
                successCallback: function(res) {
                    console.log('crud_doctor_agenda_management.js/doctor/migrate_schedule', 'POST', res);
                    $(selfForm).find('button[type="submit"]').attr('disabled', false);

                    if (res.error)
                        return Swal.fire({
                            title: 'Erro ao migrar a agenda',
                            text: res.message,
                            icon: 'error',
                            showConfirmButton: true,
                            confirmButtonText: 'OK'
                        });

                    Swal.fire({
                        title: 'Agenda do(a) ' + self.currentDoctorData.PRIMEIRO_NOME + ' migrada com sucesso!',
                        text: res.message,
                        icon: 'success',
                        showConfirmButton: true,
                        confirmButtonText: 'OK'
                    });
                    $(selfForm).trigger('reset');
                    $('#modal-doctor-migrate-agenda').modal('hide');
                },
                errorCallback: function(err) {
                    $(selfForm).find('button[type="submit"]').attr('disabled', false);
                    window.toast({
                        text: 'Ocorreu um erro ao migrar a agenda. Por favor, tente novamente',
                        type: 'error'
                    });
                    console.error('ERROR', 'crud_doctor_agenda_management.js/doctor/migrate_schedule', 'POST', err);
                }
            });
        });

        // ================== MIGRAR AGENDAMENTOS

        // ================== DELETAR AGENDA

        $(document).on('click', '.js-doctor-delete-agenda', function() {
            let doctor = $(this).data('doctor');
            self.currentDoctorData = doctor;
            //console.log('doctor', doctor);

            $('input[id="doctor_delete_agenda_branch_origin"]').val($('.js-agenda-branches-selector option:selected').text());
            $('input[id="doctor_delete_agenda_doctor_origin"]').val(doctor.PRIMEIRO_NOME);
        });

        $(document).on('submit', '.js-doctor-delete-agenda-form', function(e) {
            e.preventDefault();

            let data = $(this).serializeArray();
            let selfForm = this;
            let dateStart = $('#doctor_delete_agenda_start_date').val();
            let dateEnd = $('#doctor_delete_agenda_end_date').val();

            $(this).find('button[type="submit"]').attr('disabled', true);

            data.push({
                name: 'doctor_delete_agenda_branch_origin',
                value: self.currentDoctorData.DOUTOR_FILIAL_ID
            })
            data.push({
                name: 'doctor_delete_agenda_doctor_origin',
                value: self.currentDoctorData.STAFF_ID
            })

            window.toast({
                text: 'Aguarde, deletando a agenda... Isso pode levar alguns minutos',
                error: true,
                style: 'warning'
            });

            apiCall({
                method: 'POST',
                endpoint: `api/v1/agenda/doctor_delete_schedule`,
                data: data,
                successCallback: function(res) {
                    console.log('crud_doctor_agenda_management.js/doctor/delete_schedule', 'POST', res);
                    $(selfForm).find('button[type="submit"]').attr('disabled', false);

                    if (res.error)
                        return Swal.fire({
                            title: 'Erro ao remover a agenda',
                            text: res.message,
                            icon: 'error',
                            showConfirmButton: true,
                            confirmButtonText: 'OK'
                        });

                    Swal.fire({
                        title: 'Agenda do(a) ' + self.currentDoctorData.PRIMEIRO_NOME + ' removida com sucesso!',
                        text: 'Os horários de atendimento sem pacientes na data selecionada (' + dateStart + ' às ' + dateEnd + ') foram removidos da agenda.',
                        icon: res.error ? 'error' : 'success',
                        showConfirmButton: true,
                        confirmButtonText: 'OK'
                    });
                    $(selfForm).trigger('reset');
                    $('#modal-doctor-delete-agenda').modal('hide');
                },
                errorCallback: function(err) {
                    $(selfForm).find('button[type="submit"]').attr('disabled', false);
                    window.toast({
                        text: 'Ocorreu um erro ao remover a agenda. Por favor, tente novamente',
                        type: 'error'
                    });
                    console.error('ERROR', 'crud_doctor_agenda_management.js/doctor/delete_schedule', 'POST', err);
                }
            });
        });

        // ================== DELETAR AGENDA

        // Detecta fechamento do modal de configuração de horário
        $('#modal-doctor-hour-config').on('hidden.bs.modal', function() {
            self.multiAgendaSelectedCheckbox = [];
            self.generateFixedBarAtBottomIfHasAnySelectedCheckbox();
        });
    }

    generateFixedBarAtBottomIfHasAnySelectedCheckbox() {
        if (this.multiAgendaSelectedCheckbox.length > 0) {
            if (! $('.js-doctor-schedule-hours-fixed-bar').length) {
                $('body').append(`
                    <div class="js-doctor-schedule-hours-fixed-bar d-none fixed-bottom bg-white p-3" style="z-index: 1300;">
                        <button class="btn btn-primary js-doctor-schedule-hours-save">Excluir Horários ${this.multiAgendaSelectedCheckbox.length} Selecionados</button>
                    </div>
                `);
            }
            $('.js-doctor-schedule-hours-save').html(`Excluir Horários ${this.multiAgendaSelectedCheckbox.length} Selecionados`);
            $('.js-doctor-schedule-hours-fixed-bar').removeClass('d-none');
        } else {
            $('.js-doctor-schedule-hours-fixed-bar').addClass('d-none');
        }
    }

    updateSaveButton() {
        if (this.currentChanges.length > 0) {
            $('.js-doctor-schedule-hours-save').removeAttr('disabled');
        } else {
            $('.js-doctor-schedule-hours-save').attr('disabled', 'disabled');
        }
    }
}